export const hprFilterRange = {
  minValue: 0,
  maxValue: 27.5
};
